// extracted by mini-css-extract-plugin
module.exports = {"list":"RadioGroup_list__2iBW7","mobileModal":"RadioGroup_mobileModal__3qsOj","item":"RadioGroup_item__3aTl1"};